/**
 * Ručna korekcija kilometraže po osobi i kalendarskom mjesecu.
 * Sprema se u metrima da ostane konzistentno s dnevnim importom.
 * Doc ID: `${userId}_${year}_${month}`
 */

export function monthlyDistanceAdjustmentDocId(userId, year, month) {
  return `${userId}_${year}_${month}`;
}

/** Parsira unos korekcije u km (dozvoljen +/-), prazan string -> 0, nevaljano -> null */
export function parseDistanceAdjustmentKmInput(raw) {
  if (raw == null) return 0;
  const s = String(raw).trim();
  if (s === '') return 0;
  const n = parseFloat(s.replace(',', '.'));
  if (Number.isNaN(n)) return null;
  return n;
}

